// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"33cbfc08","436":"274b5644","525":"e5b961e2","723":"bfeab8a6"}[chunkId] + ".chunk.css";
};